import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  notification } from "antd";
import { apiServices } from "../../services/Api.js";


//get Funds data
export const getFunds = createAsyncThunk(
    "funds/getFunds",
    async (id) => {
        try {
            const response = await apiServices.post(`/customer/${id}/funds`);
            return response;
        } catch (error) {
            console.error("Error fetching funds data:", error);
            throw error;
        }
    }
);




const initialState = {
    data: [],
    loading: false,
    error: ""
};

const fundsSlice = createSlice({
    name: "funds",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getFunds.pending, (state) => {
                state.loading = true;
            })
            .addCase(getFunds.fulfilled, (state, action) => {
                state.loading = false;
                state.data = [action.payload];
            })
            .addCase(getFunds.rejected, (state) => {
                state.loading = false;
                state.error = "Error while fetching funds details";

                if (state.error) {
                    notification.error({
                        message: state.error
                    });
                }
            });
    },
});

const fundsReducer = fundsSlice.reducer;

export default fundsReducer;
